import React from "react";
import {
  Modal,
  Typography,
  Avatar,
  Tag,
  Divider,
  Row,
  Col,
  Space,
  Image,
} from "antd";
import { UserOutlined, GiftOutlined, TrophyOutlined } from "@ant-design/icons";
import moment from "moment";

const { Title, Text } = Typography;

const ORANGE = "#e2700d";

const ViewRedemption = ({ open, onClose, redemption }) => {
  if (!redemption) return null;

  const { user, reward, pointsUsed, redeemedAt } = redemption;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={650}
      bodyStyle={{ background: "#fff", padding: 24 }}
      closeIcon={<span style={{ color: ORANGE, fontSize: 18 }}>×</span>}
    >
      {/* 🔹 HEADER */}
      <Row gutter={16} align="middle">
        <Col>
          <Avatar
            size={64}
            icon={<GiftOutlined />}
            style={{ backgroundColor: ORANGE }}
          />
        </Col>

        <Col flex="auto">
          <Title level={4} style={{ marginBottom: 0 }}>
            Redemption Details
          </Title>
          <Text type="secondary">
            Redeemed on {moment(redeemedAt).format("DD MMM YYYY, hh:mm A")}
          </Text>
        </Col>

        <Col>
          <Tag color="orange">Redeemed</Tag>
        </Col>
      </Row>

      <Divider />

      {/* 🔹 USER INFO */}
      <Divider orientation="left" style={{ color: ORANGE }}>
        User
      </Divider>

      <Space align="start">
        {!user?.avatar ? (
          <Avatar size={40}>{user?.name ? user?.name.charAt(0) : "N/A"}</Avatar>
        ) : (
          <Image
            className="image-index-radius"
            size={48}
            icon={<UserOutlined />}
            src={user?.avatar}
          />
        )}

        <div>
          <Text strong>{user?.name || "-"}</Text>
          <br />
          <Text type="secondary">{user?.email || "-"}</Text>
        </div>
      </Space>

      {/* 🔹 REWARD INFO */}
      <Divider orientation="left" style={{ color: ORANGE }}>
        Reward
      </Divider>

      <Space align="start">
        <Avatar
          size={48}
          icon={<TrophyOutlined />}
          style={{ backgroundColor: ORANGE }}
        />
        <div>
          <Text strong>{reward?.name || "-"}</Text>
          <br />
          <Text type="secondary">
            Points Required: {reward?.pointsRequired?.toLocaleString() || 0}
          </Text>
        </div>
      </Space>

      <Divider />

      {/* 🔹 POINTS SUMMARY */}
      <Row>
        <Col span={12}>
          <Text>
            <GiftOutlined style={{ color: ORANGE }} /> Points Used
          </Text>
          <br />
          <Title level={5} style={{ marginTop: 4 }}>
            {pointsUsed?.toLocaleString()}
          </Title>
        </Col>

        <Col span={12}>
          <Text>
            <TrophyOutlined style={{ color: ORANGE }} /> Status
          </Text>
          <br />
          <Title level={5} style={{ marginTop: 4 }}>
            Successful
          </Title>
        </Col>
      </Row>

      <Divider />

      {/* 🔹 DATE INFO */}
      <Text type="secondary" style={{ fontSize: 12 }}>
        Redeemed At: {moment(redeemedAt).format("DD MMM YYYY, hh:mm A")}
      </Text>
    </Modal>
  );
};

export default ViewRedemption;
